module.exports = __webpack_public_path__ + "static/img/PPT.png@2x.b4db6800.png";